import login from "./login";

export default {
    permissions: {},
    init() {
        for (var i in login.data.permissions) {
            this.permissions[login.data.permissions[i].name] = true;
        }
    },
    hasPermission() {

    },
    hasPermissions(perms) {
        if (perms) {
            for (var i in perms) {
                if (!this.permissions[perms[i]]) {
                    return false;
                }
            }
        }
        return true;
    },
    hasRole() {

    },
    checkPermission() {

    },
    checkPermissions(perms) {

    },
    checkRole() {

    }
};




// WEBPACK FOOTER //
// ./src/public_app/api/permissions.js